class CollectionHighlight extends HTMLElement {
  connectedCallback() {
    this.themeSlider = this.querySelector('theme-slider');
    this.mq = window.matchMedia('(min-width: 750px)');

    this.waitForSwiper(() => {
      this.handleBreakpoint();
      this.mq.addEventListener('change', () => this.handleBreakpoint());
    });
  }

  waitForSwiper(callback) {
    if (this.themeSlider?.swiper) {
      callback();
      return;
    }
    const poll = setInterval(() => {
      if (this.themeSlider?.swiper) {
        clearInterval(poll);
        callback();
      }
    }, 50);
    setTimeout(() => clearInterval(poll), 3000);
  }

  handleBreakpoint() {
    const swiper = this.themeSlider?.swiper;
    if (!swiper) return;
    if (this.mq.matches) {
      swiper.disable();
    } else {
      swiper.enable();
    }
  }
}

customElements.define('collection-highlight', CollectionHighlight);
